
import ViewBase from '../../../view-base.view';
import UserDetailsCountryMapView from './user-details-country-map.view';
import UserDetailsInfoView from './user-details-info.view';
import UserDetailsUdfView from './user-details-udf.view';

export default function UserDetailsView() {
  ViewBase.call(this);

  return {
    view: ({ attrs }) => {
      return [
        m('div',
          m(UserDetailsInfoView, { encryptedUserId: attrs.encryptedUserId }),
          m(UserDetailsCountryMapView, { userId: attrs.userId, encryptedUserId: attrs.encryptedUserId }),
          m(UserDetailsUdfView, { userId: attrs.userId, encryptedUserId: attrs.encryptedUserId }),

          m('.col-md-12 .gap-2 .d-flex .justify-content-center',
            m(
              "button.btn.btn-white[type='button']", { onclick: () => { attrs.onClose(false); } },
              this.getText("LT00000021", "Close")
            )
          )
        ), this.getBaseViews()];
    }
  }
}


